import { parse as parsePostcode } from "postcode";

import postcodeLookup from "../postcode-lookup";

const preferredAreaByDistrict = {
	SE6: "Catford",
};

const formatAreaList = (areas) => {
	const names = areas
		.split(",")
		.map((area) => area.trim())
		.filter(Boolean);

	if (names.length < 2) return names[0] || "";
	if (names.length === 2) return names.join(" and ");

	return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
};

export default function getPostcodeArea(value) {
	if (typeof value !== "string" || !value.trim()) return null;

	const enteredPostcode = value.trim().toUpperCase().replace(/\s+/g, " ");
	const parsedPostcode = parsePostcode(enteredPostcode);
	const compactPostcode = enteredPostcode.replace(/\s/g, "");
	const outwardCode = parsedPostcode?.valid
		? parsedPostcode.subDistrict || parsedPostcode.district
		: compactPostcode;
	const district = parsedPostcode?.valid
		? parsedPostcode.district
		: compactPostcode;
	const areaList = postcodeLookup[outwardCode] || postcodeLookup[district];

	if (!areaList || areaList === "Non-geographic") return null;

	const lookupKey = postcodeLookup[outwardCode] ? outwardCode : district;
	const areaName =
		preferredAreaByDistrict[lookupKey] || areaList.split(",")[0].trim();

	return {
		areaList,
		areaListLabel: formatAreaList(areaList),
		areaName,
		district: lookupKey,
		postcode: parsedPostcode?.valid
			? parsedPostcode.postcode
			: enteredPostcode,
	};
}
